import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import i18n from 'i18next';
function getSearchKeys() {
  return {
    tag: i18n.t("property_tag").toLocaleLowerCase(),
    type: i18n.t("property_type").toLocaleLowerCase()
  };
}
function getContentTypeKeys() {
  return {
    playlist: i18n.t("content_type_playlist").toLocaleLowerCase(),
    asset: i18n.t("content_type_asset").toLocaleLowerCase(),
    topic: i18n.t("content_type_topic").toLocaleLowerCase()
  };
}

/**
 * Translates the search value into the locale language
 * i.e.
 * "tag:tag1 type:asset" => "stichwort:tag1 typ:lernbaustein"
 * @param searchValue - The search value to translate
 * @returns - The translated search value
 */
export function localiseSearchValue(searchValue) {
  var _i18n$language;
  if ((_i18n$language = i18n.language) !== null && _i18n$language !== void 0 && _i18n$language.startsWith('en')) {
    // Do nothing
    return searchValue;
  }
  var searchKeys = getSearchKeys();
  var contentTypeKeys = getContentTypeKeys();
  var reg = new RegExp("\\b(?<key>".concat(Object.keys(searchKeys).join('|'), "):(?<value>\\w+)?"), 'g');
  return searchValue.replace(reg, function () {
    for (var _len = arguments.length, match = new Array(_len), _key = 0; _key < _len; _key++) {
      match[_key] = arguments[_key];
    }
    var _match$at = match.at(-1),
      key = _match$at.key,
      value = _match$at.value;
    var localeValue = value;
    if (key === 'type' && value in contentTypeKeys) {
      localeValue = contentTypeKeys[value];
    }
    return "".concat(searchKeys[key], ":").concat(localeValue || '');
  });
}

/**
 * Converts the locale search value into an english search value
 * i.e.
 * "stichwort:tag1 typ:lernbaustein" -> "tag:tag1 type:asset"
 * @param searchValue - The search value to translate
 * @returns - The translated search value
 */
export function englifySearchValue(searchValue) {
  var _i18n$language2;
  if ((_i18n$language2 = i18n.language) !== null && _i18n$language2 !== void 0 && _i18n$language2.startsWith('en')) {
    // do nothing
    return searchValue;
  }
  var searchKeys = getSearchKeys();
  var contentTypeKeys = getContentTypeKeys();
  var reg = new RegExp("\\b(?<langkey>".concat(Object.values(searchKeys).join('|'), "):(?<langvalue>\\w+)?"), 'g');
  return searchValue.replace(reg, function () {
    for (var _len2 = arguments.length, match = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      match[_key2] = arguments[_key2];
    }
    var _match$at2 = match.at(-1),
      langkey = _match$at2.langkey,
      langvalue = _match$at2.langvalue;
    var key = Object.keys(searchKeys).find(function (key) {
      return searchKeys[key] === langkey;
    });
    var value = langvalue;
    if (key === 'type') {
      value = Object.keys(contentTypeKeys).find(function (key) {
        return contentTypeKeys[key] === langvalue;
      });
    }
    return "".concat(key, ":").concat(value || langvalue || '');
  });
}